import {parentele as body, search, stickyheader, whitelabels, mbfilter, hamburgerEl, HAS_SUB_MENU, obExtendedEl} from './constants';

const isMobile = () => window.innerWidth <= 428 // Are we handling the mobile variant?

//check if class contains in body
const hasClass = (element) =>{
  return (element.classList.contains('finda-wl') || element.classList.contains('finda-wl-mobile'))
}

//update sticky values
const updateSticky = () =>{
  whitelabels.sticky =  true;
  stickyheader.style.top = `${whitelabels.defaulttop}px`;
  stickyheader.style.position =  whitelabels.fixed;
  if(search != null){
    search.style.top = `${whitelabels.fixedtop}px`;
    search.style.position =  whitelabels.fixed;
  }
  if(isMobile){
    stickyheader.style.top = `${whitelabels.defaulttop}px`;
    (search != null)? search.style.top = `${whitelabels.fixedtop}px`:'';
    if (mbfilter) {
      mbfilter.style.position =  whitelabels.fixed;
      mbfilter.style.top = `${whitelabels.fixedtop + (whitelabels.fixedtop / 2)}px`;
    }
  }
}

//load default values
const loadDefault = () =>{
  whitelabels.sticky = false;
  stickyheader.style.position =  whitelabels.absolute;
  stickyheader.style.top = `${whitelabels.fixedtop * 2 + 6}px`;
  if(search != null){
    search.style.top = `${whitelabels.fixedtop * 3 + 6}px`;
    search.style.position =  whitelabels.absolute;
  }
  if(isMobile){
    stickyheader.style.top = `${whitelabels.defaulttop + 96}px`;
    (search != null)? search.style.top = `${whitelabels.fixedtop * 2}px` : '';
    if (mbfilter) {
      mbfilter.style.position =  whitelabels.relative;
      mbfilter.style.removeProperty("top");
    }
  }
}

//scrollhandler
const  scrollHandler =  () =>{
  // cross-browser compatible scrollTop.
  var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  // if user scrolls to 212px from the top of the header div
  if (isMobile()) {
    (scrollTop >= (whitelabels.stop / 2) - 6)? (whitelabels.sticky)? '' : updateSticky(): loadDefault();
  } else {
    (scrollTop >= whitelabels.stop)? (whitelabels.sticky)? '' : updateSticky(): loadDefault();
  }
}

//init the position
const initialize = () => {
  whitelabels.sticky = false;
  (search != null)? search.style.position =  whitelabels.unset : '';
  stickyheader.style.position =  whitelabels.unset;
}
let menuToggle = whitelabels.hamburger;

//trigger courier mail Hamburger menu
hamburgerEl.addEventListener('click', ()=>{
  menuToggle = !menuToggle;
  document.body.dataset.hamburger = menuToggle;
});

//handle hamburger sub menu
const subMenuTriggered = (event)=>{
  if(event.target.className === HAS_SUB_MENU){
    event.target.parentNode.querySelector('.mobile-navigation_li span.mobile-navigation_more').toggleAttribute('active');
    event.target.parentNode.toggleAttribute('active');
    event.target.parentNode.querySelector('.mobile-navigation_li ul').toggleAttribute('hide');
  }
}

//when resize the position
const resizehandler = () => {
  let innerWidth = document.body.clientWidth;
  if(innerWidth < whitelabels.viewports.md && isChecked()){
    addEventListener('scroll', scrollHandler, false);
    scrollHandler();
  }else if(innerWidth >= whitelabels.viewports.md && hasClass(body)){
    initialize();
    removeEventListener('scroll', scrollHandler, false);
  }
}

//condition
const isChecked  = () =>{
  let ww = document.body.clientWidth;
  return (hasClass(body) && ww < whitelabels.viewports.md);
}

//inject data-hamburger false
const loadmenu = () => {
  document.body.dataset.hamburger = menuToggle;
}
//loadevent
const loadevent = () => {
    addEventListener('DOMContentLoaded', loadDefault, false);
    addEventListener('scroll', scrollHandler, false);
    addEventListener('click', subMenuTriggered, false);
    loadmenu();
}

addEventListener('resize', resizehandler, false); //resize to adjust for fixed width

//main logic checked
(isChecked())? loadevent() : '';
